/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coinvestments_Dataroom_Togglerow3Inputs */

const en_coinvestments_dataroom_togglerow3 = /** @type {(inputs: Coinvestments_Dataroom_Togglerow3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toggle all LP access for ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Toggle all LP access for {name}" |
*
* @param {Coinvestments_Dataroom_Togglerow3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_togglerow3 = /** @type {((inputs: Coinvestments_Dataroom_Togglerow3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Togglerow3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_togglerow3(inputs)
});
export { coinvestments_dataroom_togglerow3 as "coInvestments_dataRoom_toggleRow" }